import React from 'react';
import { Route, Switch } from 'react-router-dom';

import { AboveMobile, Mobile } from '@mssgme/ui';

import { NoConversation, ConversationsBar } from '../UI';
import MessagesPage from './MessagesPage';

export default function ChatPage() {
    return (
        <>
            <AboveMobile>
                <ConversationsBar />
            </AboveMobile>
            <Switch>
                <Route path="/i/:contactId" component={MessagesPage} />
                <Route
                    render={() => (
                        <>
                            <AboveMobile>
                                <NoConversation />
                            </AboveMobile>
                            <Mobile>
                                <ConversationsBar />
                            </Mobile>
                        </>
                    )}
                />
            </Switch>
        </>
    );
}
